import { Injectable } from '@angular/core';
import { DadosLogin } from '../interfaces/dadoslogin.interface';

@Injectable({
    providedIn: 'root',
})
export class PermissionService {
    private permissionsSet = new Set<string>();
    private userPortals: string[] = [];
    private _isLoaded = false;

    setUserPermissions(dadosLogin: DadosLogin): void {
        this.permissionsSet = new Set(dadosLogin.permissoes);
        this.userPortals = dadosLogin.portais;
        this._isLoaded = true;
    }

    get isLoaded(): boolean {
        return this._isLoaded;
    }

    hasPermission(permission: string): boolean {
        return this.hasPermissionWithAllCheck(permission);
    }

    hasPermissionInCurrentPortal(
        module: string,
        resource: string,
        action: string
    ): boolean {
        const currentPortal = this.getCurrentPortal();
        const permission = this.buildPermissionString(
            currentPortal,
            module,
            resource,
            action
        );
        return this.hasPermission(permission);
    }

    hasPortalAccess(portal: string): boolean {
        return this.userPortals.includes(portal);
    }

    getCurrentPortal(): string {
        const path = window.location.pathname;
        if (path.includes('/administrador')) return 'Administrador';
        if (path.includes('/colaborador')) return 'Colaborador';
        if (path.includes('/coordenador')) return 'Coordenador';
        if (path.includes('/gestor')) return 'Gestor';
        return 'Colaborador'; // default
    }

    buildPermissionString(
        portal: string,
        module: string,
        resource: string,
        action: string
    ): string {
        const parts = [portal.toLowerCase(), module, resource, action];
        return parts.join(':');
    }

    getAvailablePortals(): string[] {
        return this.userPortals;
    }

    hasAnyPermission(permissions: string[]): boolean {
        return permissions.some(permission =>
            this.hasPermissionWithAllCheck(permission)
        );
    }

    private hasPermissionWithAllCheck(permission: string): boolean {
        // Verifica se tem a permissão exata
        if (this.permissionsSet.has(permission)) {
            return true;
        }

        // Verifica se tem a permissão com "todas" no lugar da ação
        const parts = permission.split(':');
        if (parts.length === 4) {
            const [portal, module, resource] = parts;
            const permissionWithAll = `${portal}:${module}:${resource}:todas`;
            return this.permissionsSet.has(permissionWithAll);
        }

        return false;
    }

    clearPermissions(): void {
        this.permissionsSet.clear();
        this.userPortals = [];
        this._isLoaded = false;
    }
}
